var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CockpitDialog',{attrs:{"title":_vm.title,"left":"360px","width":"1200px","height":"700px","top":"120px"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.iframeUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }